import React, { FC } from 'react'
import classNames from 'classnames'
import { PlayIcon } from '@/atoms/Icons/PlayIcon'
import { GEyebrowLG, GEyebrowMD, GResponsiveText } from '@/views/PreSales/PreSalesGiveawayView/components/Typography'

interface Props {
  text: string
  onClick: () => void
  className?: string
}
export const GiveawayPlayButton: FC<Props> = ({ onClick, text, className }) => {
  return (
    <button
      className={classNames(
        'flex min-w-fit basis-1 cursor-pointer flex-col items-center justify-center gap-2',
        className,
      )}
      onClick={onClick}
    >
      <div className="cursor-pointer rounded-[50px] bg-white px-8 py-4 backdrop-blur">
        <PlayIcon size={40} className="md:!h-[48px] md:!w-[48px]" color="giveaway-primary" />
      </div>
      <GResponsiveText
        className="uppercase text-white"
        MobileTextComponent={GEyebrowMD}
        DesktopTextComponent={GEyebrowLG}
      >
        <span style={{ textShadow: '1px 1px 0px 0px rgba(0,0,0, 0.35)' }}>{text}</span>
      </GResponsiveText>
    </button>
  )
}
